import React from 'react';

// Components
import CampaignWrapUpAnalyticsContainer from './campaign_wrap_up_analytics_container';

function CampaignWrapUpAnalytics(props) {
    const {renderForPdf, bgColor, getAssetPath} = props;

    return (
        <div className="campaign-wrap-up-analytics">
            <div className="analytics-container">
                <div className="analytics-text">
                    <div className="analytics-title">Campaign Analytics</div>
                    <div className="analytics-subtitle">
                        Your Campaign Analytics show you the amount of content created, new
                        consumers reached, engagement and effective costs.
                    </div>
                </div>

                <CampaignWrapUpAnalyticsContainer
                    contentCount={props.contentCount}
                    totalReach={props.totalReach}
                    engagements={props.engagements}
                    engagementRate={props.engagementRate}
                    ecpx={props.ecpx}
                    objectiveBid={props.objectiveBid}
                    objectiveBidType={props.objectiveBidType}
                    percentDelivered={props.percentDelivered}
                    campaignType={props.campaignType}
                    showVideoViews={props.showVideoViews}
                    renderForPdf={renderForPdf}
                    getAssetPath={getAssetPath}
                />
            </div>

            {/*STYLES*/}

            <style>{`
    .campaign-wrap-up-analytics {
    position: relative;
        bottom: 25px;
        }

        .analytics-container {
        width: 90%;
        background-color: ${bgColor};
        border: 1px solid #FFF;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        }

        .analytics-title {
        font-size: 36px;
        font-weight: 200;
        padding-top: 40px;
        }

        .analytics-subtitle {
        width: 85%;
        font-size: 20px;
        font-weight: 200;
        text-align: center;
        padding: 10px 0px 40px 0px;
        }
        `}</style>

            {/*STYLE FOR WEB*/}
            {!renderForPdf ? (
                <style>{`
        .campaign-wrap-up-analytics {
        display: flex;
        justify-content: center;
        }

        .analytics-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        }

        .analytics-text {
        display: flex;
        flex-direction: column;
        align-items: center;
        }
        `}</style>
            ) : null}

            {/*STYLE FOR PDF*/}
            {renderForPdf ? (
                <style>{`
        .campaign-wrap-up-analytics {
        padding: 20px 0px;
            page-break-before: always;
            }

            .analytics-container {
            position: relative;
            top: 70px;
            margin: auto;
            }

            .analytics-text {
            text-align: center;
            }

            .analytics-subtitle {
            margin: auto;
            }
            `}</style>
            ) : null}
        </div>
    );
}

CampaignWrapUpAnalytics.propTypes = {};

export default CampaignWrapUpAnalytics;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/campaign_wrap_up_analytics/index.js